module.exports = __webpack_public_path__ + "img/c_1.3b7af15b.png";